const LISTING_QUBIT_URL = '//d3c3cq33003psk.cloudfront.net/opentag-53841-2133550.js';
const TRAVELLER_DETAIL_QUBIT_URL = '//d3c3cq33003psk.cloudfront.net/opentag-53841-2133556.js';
const THANKYOU_QUBIT_URL = '//d3c3cq33003psk.cloudfront.net/opentag-53841-2133571.js';

export const initQubitInListing = () => addScriptToDOM (LISTING_QUBIT_URL, 'listing');
export const initQubitInTravelerDetail = () => addScriptToDOM (TRAVELLER_DETAIL_QUBIT_URL, 'traveler_detail');
export const initQubitInThankYou = () => addScriptToDOM (THANKYOU_QUBIT_URL, 'thankyou');

const addScriptToDOM = ( scriptURL, key ) => {
  let scriptArr = Array.from( document.getElementsByTagName ('script'));
  if (scriptArr.some ( (script) => script.getAttribute('data-key') === key)) {
    return;
  }
  const script = document.createElement('script');
  script.async = true;
  script.src = scriptURL;
  script.setAttribute('data-key', key);
  document.body.appendChild(script);
};

export const injectClarityScript = () => {
  const clarityScript = `
  (function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "i89xe10ve3");`;

  const scriptTag = document.createElement('script');
  scriptTag.innerHTML = clarityScript;
  window.document.head.appendChild(scriptTag);
};